import { render } from "./Scoring.vue?vue&type=template&id=02018829"
import script from "./Scoring.vue?vue&type=script&lang=js"
export * from "./Scoring.vue?vue&type=script&lang=js"

import "./Scoring.vue?vue&type=style&index=0&id=02018829&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__